import React, { useEffect, useState } from "react";
import { useBuilding } from "../../context/BuildingContext";
import { reportsApi } from "../../services/api";
import GenericReportViewer from "./GenericReportViewer";
import { dateForPeriod } from "./reportUtils";

interface Props {
  period: string;
}

const AgedCreditorsReport: React.FC<Props> = ({ period }) => {
  const { currentBuilding } = useBuilding();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<any>(null);

  useEffect(() => {
    if (!currentBuilding?.id) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await reportsApi.getAgedCreditors(currentBuilding.id, {
          date: dateForPeriod(period),
        });
        if (!cancelled) setReport(data);
      } catch (e) {
        console.error(e);
        if (!cancelled) setError("Failed to load aged creditors.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentBuilding?.id, period]);

  return (
    <GenericReportViewer
      title="Aged Creditors"
      loading={loading}
      error={error}
      report={report}
    />
  );
};

export default AgedCreditorsReport;
